import React from 'react';

const PartnersSkeleton: React.FC = () => {
    return (
        <section className="section partners-section">
            <div className="container">
                <div className="skeleton-line skeleton-title" style={{ width: '40%', height: '32px', margin: '0 auto 40px', textAlign: 'center' }}></div>
                <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '40px' }}>
                    {[...Array(6)].map((_, i) => (
                        <div key={i} className="skeleton-line" style={{ width: '120px', height: '60px', borderRadius: '8px' }}></div>
                    ))}
                </div>
                <div className="skeleton-line" style={{ width: '60%', height: '20px', margin: '0 auto 20px', textAlign: 'center' }}></div>
                <div className="skeleton-line" style={{ width: '200px', height: '48px', margin: '0 auto', borderRadius: '8px' }}></div>
            </div>
        </section>
    );
};

export default PartnersSkeleton;
